import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {OfferJourneyScreenMapping} from "./mapping/OfferJourneyMapping";
import {OfferFlowRoutingModule} from "./offer-flow-routing.module";
import {OfferFlowWrapperComponent} from "./components/offer-flow-wrapper/offer-flow-wrapper.component";
import {SharedModule} from "../shared/shared.module";
import {QuestionCardComponent} from "./components/offer-flow-wrapper/question-card/question-card.component";
import {QueUserNameComponent} from "./components/questions/que-user-name/que-user-name.component";
import {QueUserAddressComponent} from "./components/questions/que-user-address/que-user-address.component";
import {QueUserAddressVerifyComponent} from "./components/questions/que-user-address-verify/que-user-address-verify.component";
import {QueTimelineComponent} from "./components/questions/que-timeline/que-timeline.component";
import {QueHomeCostComponent} from "./components/questions/que-home-cost/que-home-cost.component";
import {QueHomeBuyComponent} from "./components/questions/que-home-buy/que-home-buy.component";
import {QueHomeBuyLocationComponent} from "./components/questions/que-home-buy-location/que-home-buy-location.component";
import {QueInviteAgentComponent} from "./components/questions/que-invite-agent/que-invite-agent.component";
import {QueAgentInfoComponent} from "./components/questions/que-agent-info/que-agent-info.component";
import {QueLogInComponent} from "./components/questions/que-log-in/que-log-in.component";
import {QueConfirmSkipHomeInfoComponent} from "./components/questions/que-confirm-skip-home-info/que-confirm-skip-home-info.component";
import {QueAreaConditionComponent} from "./components/questions/que-area-condition/que-area-condition.component";
import {QueHomeFeaturesComponent} from "./components/questions/que-home-features/que-home-features.component";
import {QueAdditionalInformationComponent} from "./components/questions/que-additional-information/que-additional-information.component";
import {QueConfirmPreferencesComponent} from "./components/questions/que-confirm-preferences/que-confirm-preferences.component";
import {QueSellingConcernsComponent} from "./components/questions/que-selling-concerns/que-selling-concerns.component";
import {FELLO_JOURNEY_TASK_SCREEN_MAPPING} from "./injection-token";
import {QueHearAboutUsComponent} from "./components/questions/que-hear-about-us/que-hear-about-us.component";
import {DynamicTooltipDirective, FelloUiLibModule, FelloUiUtilsModule} from "fello-common";
import {QueHoFutureSellingComponent} from "./components/questions/que-ho-future-selling/que-ho-future-selling.component";
import {QueFinalCardComponent} from "./components/questions/que-final-card/que-final-card.component";
import {QueNotServiceableComponent} from "./components/questions/que-not-serviceable/que-not-serviceable.component";
import {QueGoToFelloComponent} from "./components/questions/que-go-to-fello/que-go-to-fello.component";
import {QueAgentGetStartedComponent} from "./components/questions/que-agent-get-started/que-agent-get-started.component";
import {QueAgentSaleTimelineComponent} from "./components/questions/que-agent-sale-timeline/que-agent-sale-timeline.component";
import {QueAgentHomeWorthComponent} from "./components/questions/que-agent-home-worth/que-agent-home-worth.component";
import {QueAgentInviteSellerComponent} from "./components/questions/que-agent-invite-seller/que-agent-invite-seller.component";
import {SuccessRedirectComponent} from "./components/dialogs/success-redirect/success-redirect.component";
import {InstantOfferInfoComponent} from "./components/dialogs/instant-offer-info/instant-offer-info.component";
import {QueHoInvitesAgentComponent} from "./components/questions/que-ho-invites-agent/que-ho-invites-agent.component";
import {QuePhoneInputComponent} from "./components/questions/que-phone-input/que-phone-input.component";
import {QueBuyingPreferenceComponent} from "./components/questions/que-buying-preference/que-buying-preference.component";
import {QueAddressDedupeComponent} from "./components/questions/que-address-dedupe/que-address-dedupe.component";
import {
  QueConditionAdditionalBathroomComponent,
  QueConditionBaseComponent,
  QueConditionBathroomComponent,
  QueConditionFlooringComponent,
  QueConditionHomePaintComponent,
  QueConditionKitchenComponent,
  QueConditionOverallComponent
} from "./components/questions/que-condition-base/que-condition-base.component";
import {WhyEmailNeededComponent} from "./components/dialogs/why-email-needed/why-email-needed.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {QueBasementComponent} from "./components/questions/que-basement/que-basement.component";
import {QueRemodeledLocationsComponent} from "./components/questions/que-remodeled-locations/que-remodeled-locations.component";
import {QueNeutralColorPaintComponent} from "./components/questions/que-neutral-color-paint/que-neutral-color-paint.component";
import {QueContactInputComponent} from "./components/questions/que-contact-input/que-contact-input.component";
import {QueThankYouComponent} from "./components/questions/que-thank-you/que-thank-you.component";
import {QueHomeInfoUpdateComponent} from "./components/questions/que-home-info-update/que-home-info-update.component";
import {OfferFlowEasyLinkComponent} from "./components/offer-flow-easy-link/offer-flow-easy-link.component";
import {QueUserAddressConfirmationComponent} from "./components/questions/que-user-address-confirmation/que-user-address-confirmation.component";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatAutocompleteModule} from "@angular/material/autocomplete";

@NgModule({
  declarations: [
    OfferFlowWrapperComponent,
    QuestionCardComponent,
    QueUserNameComponent,
    QueUserAddressComponent,
    QueUserAddressVerifyComponent,
    QueTimelineComponent,
    QueHomeCostComponent,
    QueHomeBuyComponent,
    QueHomeBuyLocationComponent,
    QueInviteAgentComponent,
    QueAgentInfoComponent,
    QueLogInComponent,
    QueConfirmSkipHomeInfoComponent,
    QueAreaConditionComponent,
    QueHomeFeaturesComponent,
    QueAdditionalInformationComponent,
    QueConfirmPreferencesComponent,
    QueSellingConcernsComponent,
    QueHearAboutUsComponent,
    QueHoFutureSellingComponent,
    QueFinalCardComponent,
    QueNotServiceableComponent,
    QueGoToFelloComponent,
    QueAgentGetStartedComponent,
    QueAgentSaleTimelineComponent,
    QueAgentHomeWorthComponent,
    QueAgentInviteSellerComponent,
    SuccessRedirectComponent,
    InstantOfferInfoComponent,
    QueHoInvitesAgentComponent,
    QuePhoneInputComponent,
    QueBuyingPreferenceComponent,
    QueContactInputComponent,
    QueThankYouComponent,
    QueAddressDedupeComponent,
    QueConditionBaseComponent,
    QueConditionKitchenComponent,
    QueConditionBathroomComponent,
    QueConditionFlooringComponent,
    QueConditionHomePaintComponent,
    QueConditionOverallComponent,
    QueConditionAdditionalBathroomComponent,
    WhyEmailNeededComponent,
    QueBasementComponent,
    QueRemodeledLocationsComponent,
    QueNeutralColorPaintComponent,
    QueHomeInfoUpdateComponent,
    OfferFlowEasyLinkComponent,
    QueUserAddressConfirmationComponent
  ],
  imports: [
    CommonModule,
    OfferFlowRoutingModule,
    SharedModule,
    FelloUiUtilsModule,
    FelloUiLibModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    DynamicTooltipDirective
  ],
  exports: [OfferFlowEasyLinkComponent],
  providers: [
    {
      provide: FELLO_JOURNEY_TASK_SCREEN_MAPPING,
      useValue: OfferJourneyScreenMapping
    }
  ]
})
export class OfferFlowModule {}
